import styled from 'styled-components';

export const StyledScrollable = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  ${props => `
    ${props.padding && `padding: ${props.padding};`};
  `}
`

export const StyledMargin = styled.div`
  ${props => `
    ${props.margin && `margin: ${props.margin};`};
    ${props.marginTop && `margin-top: ${props.marginTop};`};
    ${props.marginRight && `margin-right: ${props.marginRight};`};
    ${props.marginBottom && `margin-bottom: ${props.marginBottom};`};
    ${props.marginLeft && `margin-left: ${props.marginLeft};`};
  `}
`


// WEBPACK FOOTER //
// ./src/components/common/styled-base.js